import { Container } from '@/atoms';
import { CardService, ProductBlock, SliderCard } from '@/molecules';

import { sectionBgProps, textStyleClass } from '@/utils';
import { getRealUrl } from '@/utils/utils';

/**
 * ComponentRevisadasServicios
 */
export const ComponentRevisadasServicios = ({
  Titulo,
  Descripcion,
  TituloEstilo,
  DescripcionEstilo,
  servicios,
  Ancla,
  FondoAzul,
  FondoSeccion,
}: any) =>
  servicios?.length > 0 ? (
    <Container
      wrapper
      id={Ancla}
      {...sectionBgProps(FondoSeccion, FondoAzul ? 'bg-primary-50' : undefined)}
    >
      <ProductBlock
        title={Titulo}
        description={Descripcion}
        titleStyleClass={textStyleClass(TituloEstilo)}
        descriptionStyleClass={textStyleClass(DescripcionEstilo)}
      >
        <SliderCard
          perPage={3}
          breakpoints={{
            1024: {
              perPage: 3,
            },
            768: {
              padding: 38,
              perPage: 2,
              gap: 16,
            },
            500: {
              padding: 30,
              perPage: 1,
            },
          }}
        >
          {servicios?.map((itm: any, index: number) => (
            <CardService
              key={`${itm.__typename}-${index}`}
              logo={
                itm.Logo && {
                  ...itm.Logo,
                  alt: itm.Logo?.alternativeText,
                  src: getRealUrl(itm.Logo?.url),
                }
              }
              title={itm.Titulo}
              description={itm.Descripcion}
              tag={itm.Tag}
            />
          ))}
        </SliderCard>
      </ProductBlock>
    </Container>
  ) : null;

ComponentRevisadasServicios.displayName = 'ComponentRevisadasServicios';
